"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiVideoSlotReel = void 0;
var _pixi = require("pixi.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiVideoSlotReel = exports.PixiVideoSlotReel = /*#__PURE__*/function (_Container) {
  function PixiVideoSlotReel(index, symbolWidth, symbolHeight, reelVSeparator, numSymbols) {
    var _this;
    _classCallCheck(this, PixiVideoSlotReel);
    _this = _callSuper(this, PixiVideoSlotReel);
    //  private _anticipationAnimation: spine.Spine;
    _defineProperty(_this, "reelIndex", void 0);
    _defineProperty(_this, "reelWidth", void 0);
    _defineProperty(_this, "reelHeight", void 0);
    _defineProperty(_this, "spinPosition", 0);
    _defineProperty(_this, "symbols", void 0);
    _defineProperty(_this, "anticipating", void 0);
    _defineProperty(_this, "stopping", void 0);
    _defineProperty(_this, "stopped", true);
    _defineProperty(_this, "_reelSymbolHeight", void 0);
    _defineProperty(_this, "_reelStage", void 0);
    _defineProperty(_this, "_numSymbols", void 0);
    _this.reelIndex = index;
    _this._reelStage = new _pixi.Container();
    _this._reelStage.name = "ReelContainer";
    _this.name = "r" + _this.reelIndex;
    _this._numSymbols = numSymbols;

    // Calculating size of single reel area
    _this.reelWidth = symbolWidth;
    _this.reelHeight = _this._numSymbols * symbolHeight + (_this._numSymbols - 1) * reelVSeparator;
    _this.addChild(_this._reelStage);
    return _this;
  }
  _inherits(PixiVideoSlotReel, _Container);
  return _createClass(PixiVideoSlotReel, [{
    key: "setSymbolsOnReel",
    value: function setSymbolsOnReel(symbols) {
      for (var c = 0; c < symbols.length; c++) {
        this.symbols[c + 1].updateSymbol(symbols[c]);
        this.symbols[c + 1].idle();
      }
    }
    /**
     * onAnticipate.
     * 
     * @param reelIndex used to determine if its this reel that is anticipating or another (if not this maybe darken and "anticipate symbol animation.")
     * @param scatterSymbols the scatter symbols relevant for this anticipate.
     */
  }, {
    key: "onAnticipate",
    value: function onAnticipate(reelIndex, scatterGroupIndex, isFreeSpin) {}
    /**
     * stop Anticipate on THIS reel.
     */
  }, {
    key: "onStopAnticipate",
    value: function onStopAnticipate(reelIndex) {}

    //#region reel events
  }, {
    key: "onSpinUp",
    value: function onSpinUp(freeSpin, reSpin) {
      for (var index = 0; index < this.symbols.length; index++) this.symbols[index].onSpinUp(freeSpin, reSpin);
    }
  }, {
    key: "onSpinStart",
    value: function onSpinStart(freeSpin, reSpin) {
      this.stopping = false;
      for (var index = 0; index < this.symbols.length; index++) this.symbols[index].onSpinStart(freeSpin, reSpin);
    }
  }, {
    key: "onSpinFullSpeed",
    value: function onSpinFullSpeed(freeSpin) {
      for (var index = 0; index < this.symbols.length; index++) this.symbols[index].onSpinFullSpeed(freeSpin);
    }
  }, {
    key: "onSpinStop",
    value: function onSpinStop(quickStop, freeSpin, reSpin) {
      for (var index = 0; index < this.symbols.length; index++) this.symbols[index].onSpinStop(quickStop, freeSpin, reSpin);
    }
  }, {
    key: "onSpinDown",
    value: function onSpinDown(quickStop, freeSpin, reSpin, anticipated) {
      for (var index = 0; index < this.symbols.length; index++) this.symbols[index].onSpinDown(quickStop, freeSpin, reSpin);
    }
  }, {
    key: "onFullStop",
    value: function onFullStop(quickStop, freeSpin, reSpin) {
      for (var index = 0; index < this.symbols.length; index++) this.symbols[index].onFullStop(quickStop, freeSpin, reSpin);
    }
    //#endregion
  }, {
    key: "onReSpin",
    value: function onReSpin(freeSpin) {}
  }]);
}(_pixi.Container);
//# sourceMappingURL=PixiVideoSlotReel.js.map